module.exports = __webpack_public_path__ + "static/media/view1_front.cfb82289.png";